// Data
import React, { useEffect, useState } from 'react';
import { checkFinalLabelDistribuitionTable, distributionOptionClassification, invertColumnOrder, isOptionValidToJustTwoWords } from '../../../../utils/distribution.js';

// Redux
import { useDispatch } from "react-redux";
import allActions from '../../../../../actions';

// Styles
import MyTable from '../../../../utils/MyTable';
import { useColors } from '../../../../../assets/styles/unoTheme';
import { applyMaskAmount, getTitleDueDate } from '../../../../utils/utils';
import { showColumnOrderIcon } from '../../../../utils/distribution';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useStyles } from './styles';
import { PUBLIC_TITLES, PRIVATE_TITLES, GENERIC_ASSETS } from '../../../../../controllers/TitleController.js';

export default function MyDistributionTable({
  handleGroupByDistributionOptions,
  setColumnOrder,
  columnOrder, selectedDistributionOption, dataToTable, listClientAssets, totalLine, endDayPortfolioPeriodSelected
}) {
  const classes = useStyles();
  const colors = useColors();
  const dispatch = useDispatch();
  const { data, mainLabel } = dataToTable;
  const { classe, maturity } = distributionOptionClassification;
  const isMaturityOption = selectedDistributionOption === maturity;


  const [propertyLabel, setPropertyLabel] = useState(classe);

  //Labels das linhas com subRows (TÍTULOS) atualmente expandidas
  const [expandedLabels, setExpandedLabels] = useState([]);

  useEffect(() => {
    setExpandedLabels([]);
  }, [selectedDistributionOption])

  function toggleExpanded(label) {
    setExpandedLabels(expandedLabels.includes(label) ?
      expandedLabels.filter(el => el !== label)
      : [...expandedLabels, label]);
  }

  function openRightContent(info, classAssets) {

    if (isMaturityOption) {
      //Ordem cronológica de vencimento; sem data ficam no fim
      classAssets.sort((a, b) => {
        const dueA = getTitleDueDate(a);
        const dueB = getTitleDueDate(b);
        if (!dueA || !dueB) return (dueA ? 0 : 1) - (dueB ? 0 : 1);
        return dueA.valueOf() - dueB.valueOf();
      });
    }

    dispatch(allActions.rightContentActions.setRightContent({
      path: 'assetsFromFormat',
      data: {
        info,
        showDueDate: isMaturityOption,
        assets:
          //Adicionado para contemplar também tab de distribuição na tela de alocação
          classAssets.length === 1
            && [PUBLIC_TITLES, PRIVATE_TITLES, GENERIC_ASSETS].includes(classAssets[0].fund_name) ?
            classAssets[0].subAssetsTitles
            :
            classAssets
      },
    }))
  }

  /**
     * Verificação se a coluna clicada já é a atualmente selecionada.
     * Se verdadeiro, nesse caso, muda-se a direção da ordenação.
     * Caso seja diferente, apenas aplica-se a order.
     * @param {String} order Ordem da coluna
     */
  function handleColumnOrder(currentColumnOrder) {
    let newColumnOrder = currentColumnOrder;
    if (currentColumnOrder == columnOrder) newColumnOrder = invertColumnOrder(currentColumnOrder);

    setColumnOrder(newColumnOrder);

    let justTwoWordsValue = isOptionValidToJustTwoWords(selectedDistributionOption);

    handleGroupByDistributionOptions(listClientAssets, selectedDistributionOption, justTwoWordsValue, newColumnOrder, endDayPortfolioPeriodSelected);
  }

  useEffect(() => {
    Object.entries(distributionOptionClassification).forEach(optionArray => {
      let option = optionArray[1];

      let isOptionSelectedOption = selectedDistributionOption === option;
      if (isOptionSelectedOption) setPropertyLabel(option);
    });

  }, [selectedDistributionOption, dataToTable])

  return (
    <>
      {data ?
        <div className={classes.divTable}>
          <MyTable selectable="true" stickyHeader size="small">
            <colgroup>
              <col width="37%" />
              <col width="25%" />
              <col width="30%" />
              <col width="8%" />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell onClick={() => handleColumnOrder('11')} align="left">{mainLabel} {showColumnOrderIcon('1', columnOrder)}</TableCell>
                <TableCell onClick={() => handleColumnOrder('21')} align="center">Percentual {showColumnOrderIcon('2', columnOrder)}</TableCell>
                <TableCell onClick={() => handleColumnOrder('31')} align="right">Valor {showColumnOrderIcon('3', columnOrder)}</TableCell>
                <TableCell align="center">Leg.</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                const isExpanded = expandedLabels.includes(row.label);
                return (
                  <React.Fragment key={'row-' + index}>
                    <TableRow
                      onClick={() => openRightContent(row, listClientAssets.filter((asset) => asset[propertyLabel] === row.label))}>
                      <TableCell component="th" scope="row">
                        {
                          row.subRows ?
                            <IconButton aria-label="expand row" size="small" style={{ padding: 0, marginRight: '4px' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleExpanded(row.label);
                              }}>
                              {isExpanded ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                            </IconButton>
                            : null
                        }
                        {checkFinalLabelDistribuitionTable(row.formatedLabel)}
                      </TableCell>
                      <TableCell align="center">{row.percent}%</TableCell>
                      <TableCell align="right" className={colors.green}>{row.formatedAmount}</TableCell>
                      <TableCell align="center">
                        {row.legColor ? <div className={classes.legendTable} style={{ background: row.legColor }}></div> : null}
                      </TableCell>
                    </TableRow>
                    {
                      row.subRows && isExpanded ?
                        row.subRows.map((subRow, subIndex) => (
                          <TableRow key={'sub-row-' + index + '-' + subIndex}
                            onClick={() => openRightContent(subRow, listClientAssets.filter((asset) =>
                              asset[propertyLabel] === row.label && asset.sector === subRow.sector))}>
                            <TableCell component="th" scope="row" style={{ paddingLeft: '44px' }}>
                              {subRow.formatedLabel}
                            </TableCell>
                            <TableCell align="center">{subRow.percent}%</TableCell>
                            <TableCell align="right" className={colors.green}>{subRow.formatedAmount}</TableCell>
                            <TableCell align="center">
                              <div className={classes.legendTable} style={{ background: subRow.legColor }}></div>
                            </TableCell>
                          </TableRow>
                        ))
                        : null
                    }
                  </React.Fragment>
                )
              })}
              {
                isMaturityOption && data.length === 0 ?
                  <TableRow>
                    <TableCell colSpan={4} align="center">Nenhum título em carteira no período</TableCell>
                  </TableRow>
                  : null
              }
            </TableBody>

            {
              data && data.length > 0 ?

                <TableFooter className={classes.myTableFooter}>
                  <TableRow key={'footer-t-distribuition'}>
                    <TableCell align="left">Total</TableCell>
                    <TableCell align="center">
                      <span className={'spanTotal'}>100%</span>
                    </TableCell>
                    <TableCell align="right">
                      <span className={'spanTotal'}>{applyMaskAmount(totalLine, true)}</span>
                    </TableCell>
                    <TableCell align="center"></TableCell>

                  </TableRow>
                </TableFooter>

                : null
            }

          </MyTable>
        </div>
        : null
      }
    </>
  )
}